import React from "react";

const Pagination = ({ page, pages, onPageChange }) => {
  if (pages <= 1) return null;


  const generatePageNumbers = () => {
  const visiblePages = [];

  if (page > 3) {
    visiblePages.push(1);
    if (page > 4) visiblePages.push("start-ellipsis");
  }

  for (let p = page - 2; p <= page + 2; p++) {
    if (p > 0 && p <= pages) {
      visiblePages.push(p);
    }
  }

  if (page < pages - 2) {
    if (page < pages - 3) visiblePages.push("end-ellipsis");
    visiblePages.push(pages);
  }

  // ✅ remove duplicates
  return [...new Set(visiblePages)];
};


  // const generatePageNumbers = () => {
  //   const visiblePages = [];

  //   // Always show first page
  //   if (page > 3) {
  //     visiblePages.push(1);
  //     if (page > 4) visiblePages.push("...");
  //   }

  //   // Show pages around current page
  //   for (let p = page - 2; p <= page + 2; p++) {
  //     if (p > 0 && p <= pages) {
  //       visiblePages.push(p);
  //     }
  //   }

  //   // Always show last page
  //   if (page < pages - 2) {
  //     if (page < pages - 3) visiblePages.push("...");
  //     visiblePages.push(pages);
  //   }

  //   return visiblePages;
  // };

  const pageNumbers = generatePageNumbers();

  return (
    <nav>
      <ul className="pagination mb-0 d-flex align-items-center">

        {/* Prev Button */}
        <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => onPageChange(page - 1)}>
            Previous
          </button>
        </li>


        {pageNumbers.map((p, index) =>
  typeof p === "string" ? (
    <li key={p + index} className="page-item disabled">
      <span className="page-link">...</span>
    </li>
  ) : (
    <li
      key={`page-${p}`}     // ✅ unique key
      className={`page-item ${p === page ? "active" : ""}`}
    >
      <button className="page-link" onClick={() => onPageChange(p)}>
        {p}
      </button>
    </li>
  )
)}


        {/* {pageNumbers.map((p, index) =>
          p === "..." ? (
            <li key={index} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          ) : (
            <li
              key={p}
              className={`page-item ${p === page ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => onPageChange(p)}>
                {p}
              </button>
            </li>
          )
        )} */}

        {/* Next Button */}
        <li className={`page-item ${page === pages ? "disabled" : ""}`}>
          <button className="page-link" onClick={() => onPageChange(page + 1)}>
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
